import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUserData, updateUser } from "../../../store/users";
import {
  deleteInvitation,
  getCurrentUserInvitation,
} from "../../../store/invitations";
import { deleteGroup, getGroupById, updateGroup } from "../../../store/groups";
import Invitation from "../../../ui/invitation/Invitation";
import { createDeletedElemReject } from "../../../store/delete";
import localStorageService from "../../../service/http.localStorage";
import ModalShell from "./ModalShell";
import { useI18n } from "../../../i18n/LanguageContext";
// import { getIdentifyById } from "../../../store/identify";

const AddToTeamModal = ({ onShowModal }) => {
  const currentUser = useSelector(getCurrentUserData());
  const invitation = useSelector(getCurrentUserInvitation());

  const group = useSelector(getGroupById(invitation?.groupId));
  // const identify = useSelector(getIdentifyById(group._id));
  const dispatch = useDispatch();
  const { t } = useI18n();
  const closeRef = useRef(() => {});
  const requestClose = () => closeRef.current();

  // проверяет приглашение и обновляет членов группы
  const findGroupAndUpdate = async (invitation) => {
    const newMembers = group.members.map((elem) => {
      return elem.member !== invitation.to ? elem : { ...elem, accept: true };
    });
    let payload = {
      ...group,
      members: newMembers,
    };
    dispatch(updateGroup(payload));
  };

  const handleAccept = () => {
    if (invitation !== null && currentUser) {
      dispatch(updateUser({ ...currentUser, teamId: invitation.groupId }));
      findGroupAndUpdate(invitation);
      const local = localStorageService.getGroupId();
      !local && localStorage.setItem("group-local-id", invitation.groupId);
      dispatch(deleteInvitation());

      requestClose();
    }
  };
  const handleReject = async (e) => {
    e.preventDefault();
    if (!group?.members) return;
    if (group.members.length > 2) {
      // исключаем отказавшегося и берём остальных
      const others = group.members.filter((m) => m.member !== invitation.to);
      console.log("others", others.length);
      if (others.length === 2) {
        // первого оставляем как "создателя", второго помечаем как удалённого
        await dispatch(
          createDeletedElemReject({
            userId: others[1].member,
            removeInvitation: true,
          })
        );
        await dispatch(
          createDeletedElemReject({
            userId: others[0].member,
            removeInvitation: false,
          })
        );
      }
    } else {
      // если в группе только 2 человека
      await dispatch(
        createDeletedElemReject({
          userId: group.members[0].member,
          removeInvitation: false,
        })
      );
    }

    // чистим всё остальное
    dispatch(deleteGroup({ groupId: invitation.groupId }));
    dispatch(deleteInvitation());
    requestClose();
  };

  const closeButton = (
    <button
      className="btn-smooth w-full px-6 py-2 text-sm font-bold uppercase text-red-500 outline-none sm:w-auto"
      type="button"
      onClick={requestClose}
    >
      {t("common.close")}
    </button>
  );

  return (
    <ModalShell
      panelClassName="max-w-lg sm:max-w-2xl"
      onClose={() => onShowModal()}
      closeRef={closeRef}
    >
      <div className="relative flex w-full min-w-0 flex-col rounded-lg border-0 bg-white shadow-lg outline-none">
        <div className="flex items-start justify-between gap-3 rounded-t border-b border-solid border-slate-200 p-4 sm:p-5">
          <h3 className="min-w-0 text-xl font-semibold sm:text-3xl">
            {t("add.title")}
          </h3>
          <button
            className="btn-smooth shrink-0 border-0 bg-transparent p-1 text-2xl font-semibold leading-none text-black outline-none"
            onClick={requestClose}
            type="button"
            aria-label={t("common.close")}
          >
            ×
          </button>
        </div>
        <div className="relative flex-auto p-4 sm:p-6">
          <p className="text-base leading-relaxed text-slate-500 sm:text-lg">
            {t("add.text")}
          </p>
        </div>
        {invitation !== null ? (
          <div>
            <div className="flex justify-center px-3 py-2">
              <Invitation />
            </div>
            <div className="flex flex-col gap-2 rounded-b border-t border-solid border-slate-200 p-4 sm:flex-row sm:items-center sm:justify-end sm:p-6">
              {closeButton}
              <button
                className="btn-smooth w-full rounded bg-emerald-500 px-6 py-3 text-sm font-bold uppercase text-white shadow outline-none hover:bg-emerald-600 sm:w-auto"
                type="button"
                onClick={handleAccept}
              >
                {t("add.accept")}
              </button>
              <button
                className="btn-smooth w-full rounded bg-emerald-500 px-6 py-3 text-sm font-bold uppercase text-white shadow outline-none hover:bg-emerald-600 sm:w-auto"
                type="button"
                onClick={handleReject}
              >
                {t("add.reject")}
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className="flex justify-center p-4 text-center">
              {group === null ? (
                    <p>{t("add.none")}</p>
              ) : (
                    <p>{t("add.inGroup")}</p>
              )}
            </div>
            <div className="flex items-center justify-end rounded-b border-t border-solid border-slate-200 p-4 sm:p-6">
              {closeButton}
            </div>
          </>
        )}
      </div>
    </ModalShell>
  );
};

export default AddToTeamModal;
